// Request status constants
export const INITIAL = {
  initial: true,
  pending: false,
  completed: false,
  failed: false,
}

export const PENDING = {
  initial: false,
  pending: true,
  completed: false,
  failed: false,
}

export const COMPLETED = {
  initial: false,
  pending: false,
  completed: true,
  failed: false,
}

export const FAILED = {
  initial: false,
  pending: false,
  completed: false,
  failed: true,
}

export const INITIAL_API = {
  resources: {
    one: {
      status: INITIAL,
      data: {},
    },
    list: {
      status: INITIAL,
      data: [],
    },
    actionStatus: INITIAL,
  },
  eventType: {
    one: {
      status: INITIAL,
      data: {},
    },
    list: {
      status: INITIAL,
      data: [],
    },
  },
  resourceType: {
    one: {
      status: INITIAL,
      data: {},
    },
    list: {
      status: INITIAL,
      data: [],
    },
    actionStatus: INITIAL,
  },
}
